// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import OffersTable from './offers-table';
// assets
//

// ----------------------------------------------------------------------

export default function OffersProduct() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <OffersTable />
        </Container >
    );
}
